// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import Axios from './utils/myaxios'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import { Message, Upload, DatePicker, Select, Option, Button, Tree, Input } from 'element-ui'
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/dataset'
import {VueMarkdownEditor, VMdPreview} from './utils/markdown'
import 'vue-search-select/dist/VueSearchSelect.css'
import draggable from 'vuedraggable'
import VueClipboard from 'vue-clipboard2'
import VueScrollTo from 'vue-scrollto'

import App from './App'

Vue.use(BootstrapVue)
Vue.use(Upload)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(Tree)
Vue.use(Input)
Vue.use(VueMarkdownEditor)
Vue.use(VMdPreview)
Vue.use(VueClipboard)

let scrollOptions = {
  container: 'body', // 滚动的容器
  duration: 500, // 滚动时间
  easing: 'ease', // 缓动类型
  offset: -50, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true,
  onStart: false,
  onDone: function (element) {
    let titleHr = element.children[1].children[0]
    titleHr.style = 'background: #e2f0fd; transition: background 0.5s ease 0s;'
    setTimeout(() => {
      titleHr.style.background = ''
    }, 500)
  },
  onCancel: false,
  x: false,
  y: true
}
Vue.use(VueScrollTo, scrollOptions)

Vue.component('echart', ECharts)
Vue.component('draggable', draggable)

Vue.prototype.$message = Message
Vue.prototype.$ajax = Axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js